import { Button, Grid } from "@mui/material";
import ImagesUploaderForm from "../ImagesUploaderForm/ImagesUploaderForm";
import DialogService from "../Dialog/dialogService";
import HeaderImg from "../HeaderImg/HeaderImage";

interface HeaderImgFormProps {
  imageUrl: string | undefined;
  setValue?: Function;
}

export const HeaderImgForm = ({ imageUrl, setValue }: HeaderImgFormProps) => {
  const { openXS } = DialogService();

  const openModal = () => {
    if (setValue) {
      openXS(
        "Change Header Image",
        <ImagesUploaderForm defaultName="header" addImage={setValue} />,
        []
      );
    }
  };
  return (
    <Grid item container direction="column" rowSpacing={0.5}>
      <Grid item>
        <HeaderImg headerImageUrl={imageUrl} />
      </Grid>
      <Grid item>
        <Button
          variant={"customBlueTextUnderLine"}
          sx={{
            textDecorationThickness: "2px",
            textUnderlineOffset: "5px",
            fontWeight: "500 !important",
          }}
          onClick={openModal}
        >
          Change Image
        </Button>
      </Grid>
    </Grid>
  );
};

export default HeaderImgForm;
